import {createReducer, on} from '@ngrx/store';
import * as paymentsProfileActions from './payments-profile-actions';
import * as fromPaymentsProfile from './payments-profile-state';
import {PaymentProfileCollection} from '@app/marketplace/checkout/_models/payment-profile.model';

const initialState: fromPaymentsProfile.State = {isLoading: false, data: {data: []} as PaymentProfileCollection, paymentResponse: null, validateResponse: null, cancelResponse: null};
export const reducer = createReducer(
  initialState,
  on(paymentsProfileActions.LoadingPaymentsProfile, (state) => {
    return {...state, isLoading: true};
  }),
  on(paymentsProfileActions.ListPaymentsProfile, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(paymentsProfileActions.PurchaseToken, (state) => {
    return {...state, isLoading: true};
  }),
  on(paymentsProfileActions.PurchaseNewCard, (state) => {
    return {...state, isLoading: true};
  }),
  on(paymentsProfileActions.PaymentResponse, (state, { data}) => {
    return {...state, isLoading: false, paymentResponse: data};
  }),
  on(paymentsProfileActions.ValidatingCard, (state) => {
    return {...state, isLoading: true};
  }),
  on(paymentsProfileActions.Validating3DSecureCard, (state) => {
    return {...state, isLoading: true};
  }),
  on(paymentsProfileActions.ValidatedCardResponse, (state, { data}) => {
    return {...state, isLoading: false, validateResponse: data};
  }),
on(paymentsProfileActions.CancelingPayment, (state) => {
  return {...state, isLoading: true};
}),
  on(paymentsProfileActions.CanceledPayment, (state, { data}) => {
    return {...state, isLoading: false, cancelResponse: data};
  }),
  on(paymentsProfileActions.ClearPayment, (state) => {
    return {...state, isLoading: false, cancelResponse: null, validateResponse: null, paymentResponse: null};
  }),
  on(paymentsProfileActions.CloseErrorMessage, ( state) => {
    state.paymentResponse.success = true;
    return state;
  }),
);
